import(/* webpackMode: "eager" */ "/app/front_end/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/app/front_end/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/front_end/src/components/katex_renderer/index.tsx");
